import { request, withQuery } from './client';
import type { QuickButton, OutletPayMethods, PayMethods, RoleGrant, RolesResponse } from '@kassa/shared';

// Rollar və ödəniş növləri (KT-95)
export const settingsApi = {
  roles: () => request<RolesResponse>('GET', '/api/settings/roles'),
  roleSetPermissions: (roleId: string, permissions: RoleGrant[]) =>
    request<{ roleId: string; count: number }>('PUT', `/api/settings/roles/${encodeURIComponent(roleId)}/permissions`, { permissions }),
  roleCreate: (name: string, copyFrom: string | null) => request<{ id: string }>('POST', '/api/settings/roles', { name, copyFrom }),
  payMethodsSettings: () => request<OutletPayMethods[]>('GET', '/api/settings/payment-methods'),
  payMethodsSave: (outletId: string, methods: PayMethods) =>
    request<PayMethods>('PUT', `/api/settings/payment-methods/${encodeURIComponent(outletId)}`, methods),
  // Tez düymələr (KT-101)
  quickButtonsSettings: (outletId: string) => request<QuickButton[]>('GET', `/api/settings/quick-buttons/${encodeURIComponent(outletId)}`),
  quickButtonsSave: (outletId: string, productIds: string[]) =>
    request<QuickButton[]>('PUT', `/api/settings/quick-buttons/${encodeURIComponent(outletId)}`, { productIds }),
  saleQuickButtons: (registerId: string) => request<QuickButton[]>('GET', withQuery('/api/sales/quick-buttons', { registerId })),
  // Bonus faizi (KT-96)
  bonusSettings: () => request<{ pct: number }>('GET', '/api/settings/bonus'),
  bonusSettingsSave: (pct: number) => request<{ pct: number }>('PUT', '/api/settings/bonus', { pct }),
  salePayMethods: (registerId: string) => request<PayMethods>('GET', withQuery('/api/sales/payment-methods', { registerId })),
};
